import AboutImage from '../../assets/about.jpg'
import data from './data'
import Card from '../../components/Card'
import './about.css'

const About = () => {
  return (
    <section id="about" data-aos="fade-up">
      <div className="container about__container">
  <div className="about__left">
    <div className="about__portrait">
      <img src={AboutImage} alt="About portrait" />
    </div>
  </div>

  <div className="about__right">
    <h2>About Me</h2>
    <div className="about__cards">
      {data.map(item => (
        <Card key={item.id} className="about__card">
          <span className="about__card-icon">{item.icon}</span>
          <h5>{item.title}</h5>
          <small>{item.desc}</small>
        </Card>
      ))}
    </div>

    <div className="about__code">
      <p><span className="code-tag">&lt;developer&gt;</span></p>
      <p><span className="code-comment">{'// CS + Applied Mathematics @ Furman University'}</span></p>
      <p><span className="code-comment">{'// Languages: Python · TypeScript · C# · JavaScript · SQL'}</span></p>
      <p><span className="code-comment">{'// Focus: AI Engineering · Web Dev · Software Development'}</span></p>
      <p><span className="code-comment">{'// Driven by math, logic & real-world impact'}</span></p>
      <p><span className="code-tag">&lt;/developer&gt;</span></p>
    </div>

  </div>
  </div>
    </section>
  )
}

export default About